import React, { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { gameActions } from '../../actions';

// Components
import { GameForm } from './form';
import { GameSetup } from './setup';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';
import GameHistogram from './debrief_histogram';
import { GameLeaderboard } from './leaderboard';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  useEffect(() => {
    dispatch(gameActions.fetchGames(id));
  }, [dispatch, id]);

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameSetup
      : GameForm;

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />
            <Route path='debrief/overview' element={<GameDebrief />} />
            <Route path={`debrief/histogram`} element={<GameHistogram />} />
            <Route path='debrief/leaderboard' element={<GameLeaderboard />} />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
